var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedStepBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 34,
    viewBox: "0 0 263 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 237,
    height: 33,
    transform: "matrix(1 0 0 -1 0.995972 33.0159)",
    fill: "#DC4C4C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 261.996,
    y: 33.0159,
    width: 33,
    height: 1,
    transform: "rotate(-90 261.996 33.0159)",
    fill: "url(#paint0_linear_314_1399)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 239.996,
    y: 33.0159,
    width: 33,
    height: 1.00002,
    transform: "rotate(-90 239.996 33.0159)",
    fill: "url(#paint1_linear_314_1399)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 254.996,
    y: 33.0159,
    width: 33,
    height: 1.00002,
    transform: "rotate(-90 254.996 33.0159)",
    fill: "url(#paint2_linear_314_1399)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 241.996,
    y: 33.0159,
    width: 33,
    height: 2.00002,
    transform: "rotate(-90 241.996 33.0159)",
    fill: "url(#paint3_linear_314_1399)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 246.996,
    y: 33.0159,
    width: 33,
    height: 3.00002,
    transform: "rotate(-90 246.996 33.0159)",
    fill: "url(#paint4_linear_314_1399)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 250.996,
    y: 33.0159,
    width: 33,
    height: 1.00002,
    transform: "rotate(-90 250.996 33.0159)",
    fill: "url(#paint5_linear_314_1399)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_314_1399",
    x1: 278.496,
    y1: 33.0159,
    x2: 278.496,
    y2: 34.0159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_314_1399",
    x1: 256.496,
    y1: 33.0159,
    x2: 256.496,
    y2: 34.0159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_314_1399",
    x1: 271.496,
    y1: 33.0159,
    x2: 271.496,
    y2: 34.0159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_314_1399",
    x1: 258.496,
    y1: 33.0159,
    x2: 258.496,
    y2: 35.0159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_314_1399",
    x1: 263.496,
    y1: 33.0159,
    x2: 263.496,
    y2: 36.0159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_314_1399",
    x1: 267.496,
    y1: 33.0159,
    x2: 267.496,
    y2: 34.0159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedStepBg);
export default __webpack_public_path__ + "static/media/red-step-bg.132df2e536e67fa1d9a9ed22d46e8a47.svg";
export { ForwardRef as ReactComponent };